var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-avatar',{attrs:{"size":"100px"}},[(_vm.url)?_c('img',{attrs:{"alt":"Avatar","src":_vm.url}}):_vm._e()]),_vm._v(" "),_c('v-file-input',{on:{"change":_vm.fileupload},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}}),_vm._v("\n  "+_vm._s(_vm.url)+"\n\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca10412","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/System/FileUpload.vue
// module id = null
// module chunks = 